import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import {Link} from "@reach/router";
import FlickitySlider from "./FlickitySlider";

class HomePhotoshoot extends Component{
  render(){
    let children = [];
    this.props.data.items.forEach((item, index) => {
      children.push(
          <div key={'ph' + index} className="carousel-cell">
            <Link to={item.url}>
              <div className="carou-item">
                <img src={item.image} />
              </div>
            </Link>
          </div>
      );
    });
    return(
      <>
      <div className="photoshoot-slider">
        <div className="container">
          <h4>{this.props.nick} Photoshoot</h4>
        </div>
        <FlickitySlider options={{ "freeScroll": true, "contain": true, "prevNextButtons": false, "pageDots": false }}>
          {children}
          <div className="div-last-slider"></div>
        </FlickitySlider>
      </div>
      </>
    );
  }
}

export default HomePhotoshoot;
